/* eslint-disable class-methods-use-this */
import { DashboardSortBy } from "../../../__generated__/api";
import TicketItem from "../ticket-item";
import { SORT_REGISTRY, SortBy } from "./base";

export default class SortByManual extends SortBy {
    public static shouldCreate(sortBy: DashboardSortBy): boolean {
        return sortBy === DashboardSortBy.Manual;
    }

    public sort(chats: TicketItem[]): TicketItem[] {
        return chats;
    }
}

SORT_REGISTRY.register(SortByManual);
